export const formatPrice = (price: number, priceMask: string, noRound?: boolean, noPoint?: boolean): string =>
  price != null && price != undefined && price.toFixed && priceMask
    ? priceMask.replace(
        '{{price}}',
        '<ins>' +
          '&zwj;' +
          price.toFixed(2).split('.')[0] +
          '&zwj;' +
          '</ins>' +
          '<sub>' +
          (!noRound && price >= 100 ? '' : (noPoint ? '' : '.') + price.toFixed(2).split('.')[1]) +
          '</sub>'
      )
    : '---'
